/* Lens reveal: maps scroll through the section to one 0–1 progress value and drives the stage from it */
(function () {
  if (customElements.get('lens-reveal')) return;
  var ACUITY = ['20/200', '20/100', '20/70', '20/50', '20/40', '20/30', '20/25', '20/20'];
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var range = function (p, a, b) { return clamp((p - a) / (b - a), 0, 1); };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  customElements.define('lens-reveal', class extends HTMLElement {
    connectedCallback() {
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.readout = this.querySelector('[data-lr-readout]');
      this.steps = parseInt(this.dataset.steps, 10) || 0;
      this.tick = this.tick.bind(this);
      this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(this.tick); };
      this.onMotion = () => this.mode();
      if (this.reduce.addEventListener) this.reduce.addEventListener('change', this.onMotion);
      this.mode();
    }
    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.reduce.removeEventListener) this.reduce.removeEventListener('change', this.onMotion);
    }
    mode() {
      if (this.classList.contains('is-static') || this.reduce.matches) { this.stop(); if (this.io) this.io.disconnect(); this.io = null; this.paint(1); return; }
      if (this.io) return;
      this.io = new IntersectionObserver((es) => { es.forEach((e) => { if (e.isIntersecting) this.start(); else this.stop(); }); }, { rootMargin: '10% 0px' });
      this.io.observe(this);
      this.tick();
    }
    start() {
      if (this.live) return;
      this.live = true;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.tick();
    }
    stop() {
      this.live = false;
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
    }
    tick() {
      this.raf = 0;
      var r = this.getBoundingClientRect();
      var travel = r.height - window.innerHeight;
      this.paint(travel > 0 ? clamp(-r.top / travel, 0, 1) : 1);
    }
    paint(p) {
      var vw = window.innerWidth, vh = window.innerHeight;
      // Glasses start roughly face width and grow until one lens fills the screen
      var base = Math.min(vw * (vw < 750 ? .78 : .44), 620);
      var grow = ease(range(p, .1, .86));
      // One lens is 88/220 of the glasses wide and 72/220 tall; this scale makes it cover the whole screen
      var need = Math.max(vw / (base * .4), vh / (base * .327)) * 1.25;
      var s = 1 + (need - 1) * grow;
      var w = base * s;
      // Drift the left lens (centre at 50/220) onto the screen centre so the bridge never splits the view
      var x = w * (60 / 220) * ease(range(p, .1, .55));
      var st = this.style;
      st.setProperty('--lr-w', w.toFixed(1) + 'px');
      st.setProperty('--lr-x', x.toFixed(1) + 'px');
      st.setProperty('--lr-frame-o', (1 - range(p, .3, .62)).toFixed(3));
      st.setProperty('--lr-split', ease(range(p, .06, .6)).toFixed(4));
      st.setProperty('--lr-title-o', (1 - range(p, .32, .58)).toFixed(3));
      st.setProperty('--lr-zoom', (1.12 - .12 * range(p, 0, 1)).toFixed(4));
      if (this.steps) {
        var step = Math.min(this.steps, Math.floor(range(p, .02, .9) * this.steps) + 1);
        if (this.dataset.step !== String(step)) this.dataset.step = step;
      }
      if (this.readout) {
        var a = ACUITY[Math.min(ACUITY.length - 1, Math.floor(range(p, .05, .85) * (ACUITY.length - 1) + .0001))];
        if (this.readout.textContent !== a) this.readout.textContent = a;
      }
    }
  });
})();
